<div
  class="loader-container"
  [@rotateOnLoop]="rotationState"
  [ngStyle]="getSpinnerDimensions()"
>
  <img
    *ngFor="let frame of frames; let i = index"
    [src]="frame"
    class="loader-frame"
    [class.active]="i === currentFrameIndex"
    alt="loader frame"
  />
</div>
